// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__3roSa","title":"style_title__xhx2t","icon":"style_icon__qSzzT","isBpSmall":"style_isBpSmall__9Ifos"};